// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { ACCOUNT_URLS } from 'Route/MyAccount/MyAccount.config';
import { CustomerType } from 'Type/Account.type';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

import MyAccountBanner from './MyAccountBanner.component';

/** @namespace PeggysagePwa/Component/MyAccountBanner/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    customer: state.MyAccountReducer.customer
});

/** @namespace PeggysagePwa/Component/MyAccountBanner/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/MyAccountBanner/Container */
export class MyAccountBannerContainer extends PureComponent {
    static propTypes = {
        customer: CustomerType.isRequired
    };

    state = {
        isAccountPage: false,
        isEnabled: false,
        isPro: false,
        isStudent: false
    };

    containerFunctions = {
        // getData: this.getData.bind(this)
    };

    componentDidMount() {
        const { location } = history;

        history.listen((location) => {
            this.onRouteChanged(location);
        });
        this.onRouteChanged(location);

        this.getCustomerGroup();
    }

    componentDidUpdate(prevProps) {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;
        const { customer: { group_id: prevGroupId = 0 } = {} } = prevProps;

        if (groupId !== prevGroupId) {
            this.getCustomerGroup();
        }
    }

    handleDisplay() {
        const { isAccountPage, isPro, isStudent } = this.state;

        this.setState({ isEnabled: (isPro || isStudent) && isAccountPage });
    }

    getCustomerGroup() {
        const { customer: { is_pro = false, is_student = false } = {} } = this.props;

        this.setState({
            isPro: is_pro,
            isStudent: is_student
        }, () => this.handleDisplay());
    }

    onRouteChanged(location) {
        const { pathname = appendWithStoreCode('/') } = location;

        this.setState({
            isAccountPage: ACCOUNT_URLS.some((url) => pathname.match(appendWithStoreCode(url)))
        }, () => this.handleDisplay());
    }

    containerProps() {
        const { isEnabled, isPro, isStudent } = this.state;

        return {
            isEnabled,
            isPro,
            isStudent
        };
    }

    render() {
        return (
            <MyAccountBanner
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountBannerContainer);
